import { render, staticRenderFns } from "./AppEchartRadar.vue?vue&type=template&id=6722c4f5"
import script from "./AppEchartRadar.vue?vue&type=script&lang=js"
export * from "./AppEchartRadar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports